import React, { FC } from "react";
import { Fade } from "react-awesome-reveal";
import classNames from "classnames";
import { GatsbyImage } from "gatsby-plugin-image";
import { getGatsbyImage } from "gatsby-plugin-storyblok-image";
import {
  BlockHeader,
  HeaderLevel,
} from "@app/components/common/block-header/BlockHeader";
import { BlockBody } from "@app/components/common/block-body/BlockBody";
import { checkFileType, FileType } from "@app/helpers/check-file-type";
import { IIconCard } from "@app/models/storyblok/blocks/icon-cards-list";
import { DEFAULT_FADE_DURATION } from "@app/constants";

type Props = {
  data: IIconCard[];
};

export const Cards: FC<Props> = ({ data }) => (
  <Fade duration={DEFAULT_FADE_DURATION} triggerOnce cascade>
    <div
      className={classNames(
        "space-y-10",
        "md:grid md:grid-cols-2 md:gap-8 md:space-y-0",
        "xl:gap-12",
      )}
    >
      {data.map((item) => (
        <div
          key={item._uid}
          className={classNames(
            "border-divider text-regular text-primary-content rounded-lg border border-solid px-9 py-10",
            "xl:py-11",
          )}
        >
          <div className="mb-5 flex flex-col items-start justify-center">
            {item.icon?.filename ? (
              checkFileType(item.icon?.filename) === FileType.IMAGE ? (
                <GatsbyImage
                  image={getGatsbyImage(item.icon.filename, {
                    layout: "fixed",
                  })}
                  alt={item.icon.alt ?? "Icon"}
                  className="max-h-12 max-w-16"
                />
              ) : (
                <img
                  src={item.icon.filename}
                  alt={item.icon.alt ?? "Icon"}
                  className="max-h-12 max-w-16"
                />
              )
            ) : null}
          </div>
          <BlockHeader
            richText={item.title}
            headerLevel={HeaderLevel.H3}
            className={classNames(
              "text-medium max-w-[86%]",
              "lg:max-w-full",
              "xl:text-large",
            )}
          />
          <div className="mt-2.5">
            <BlockBody richText={item.text} />
          </div>
        </div>
      ))}
    </div>
  </Fade>
);
